import { createStore as createVuexStore } from 'vuex'
import apiSecrets from './apiSecrets'
import auth from './auth'
import contacts from './contacts'
import countries from './countries'
import docStatuses from './docStatuses'
import treasuryDocs from './treasuryDocs'
import mbway from './mbway'
import explainer from './explainer'
import memberPhotos from './memberPhotos'
import memberApplicationPhotos from './memberApplicationPhotos'
import memberStateNames from './memberStateNames'
import memberStates from './memberStates'
import members from './members'
import membershipCards from './membershipCards'
import membershipCardLetters from './membershipCardLetters'
import memberApplications from './memberApplications'
import menuItem from './menuItem'
import messages from './messages'
import paymentAdvice from './paymentAdvice'
import paymentMessage from './paymentMessage'
import pdfDocuments from './pdfDocuments'
import payments from './payments'
import people from './people'
import reports from './reports'
import settings from './settings'
import tags from './tags'
import treasuryDocsStatuses from './treasuryDocsStatuses.js'
import toolbar from './toolbar'
import unsettledPayments from './unsettledPayments'
import users from './users'

export const createStore = (app) => {
  return createVuexStore({
    state: {
      responseTime: 0,
      debug: false,
      appReady: false,
      serverStatus: 'ok',
      offline: false,
    },
    mutations: {
      setResponseTime(state, responseTime) {
        Object.assign(state, { responseTime })
      },
      toggleDebug(state) {
        state.debug = !state.debug
      },
      appReady(state, v) {
        state.appReady = v
      },
      serverStatus(state, v) {
        state.serverStatus = v
      },
      setOffline(state, v) {
        state.offline = v
      },
    },
    actions: {
      setResponseTime(context, v) {
        context.commit('setResponseTime', v)
      },
      toggleDebug(context) {
        context.commit('toggleDebug')
      },
      appReady(context, v) {
        context.commit('appReady', v)
      },
      serverStatus(context, v) {
        context.commit('serverStatus', v)
      },
      setOffline(context, v) {
        context.commit('setOffline', v)
      },
    },
    modules: {
      apiSecrets: apiSecrets(app),
      auth: auth(app),
      contacts: contacts(app),
      countries: countries(app),
      docStatuses: docStatuses(app),
      explainer: explainer(app),
      mbway: mbway(app),
      memberPhotos: memberPhotos(app),
      memberStateNames: memberStateNames(app),
      memberStates: memberStates(app),
      members: members(app),
      memberApplications: memberApplications(app),
      memberApplicationPhotos: memberApplicationPhotos(app),
      membershipCards: membershipCards(app),
      membershipCardLetters: membershipCardLetters(app),
      menuItem: menuItem(app),
      messages: messages(app),
      paymentAdvice: paymentAdvice(app),
      paymentMessage: paymentMessage(app),
      payments: payments(app),
      pdfDocuments: pdfDocuments(app),
      people: people(app),
      reports: reports(app),
      settings: settings(app),
      tags: tags(app),
      toolbar: toolbar(app),
      treasuryDocs: treasuryDocs(app),
      treasuryDocsStatuses: treasuryDocsStatuses(app),
      unsettledPayments: unsettledPayments(app),
      users: users(app),
    },
  })
}
